const HERO_CATEGORIES = ['Cartomanti', 'Sensitivi', 'Astrologi', 'Esperti di tarocchi', 'Numerologi'];

export function HeroBanner() {
  return (
    <section className="px-4 pb-5" aria-label="Banner principale">
      <div className="mx-auto max-w-6xl">
        <div className="group relative w-full overflow-hidden rounded-xl border border-brand-teal/20 bg-brand-navy shadow-[0_2px_20px_rgba(24,153,170,0.12)] aspect-[3/2] sm:aspect-[21/8] transition-shadow duration-300 [@media(hover:hover)]:hover:shadow-[0_4px_30px_rgba(24,153,170,0.18)]">
          <img
            src="/images/hero-home.png"
            alt=""
            role="presentation"
            aria-hidden="true"
            width={1360}
            height={768}
            decoding="async"
            className="absolute inset-0 h-full w-full object-cover object-center transition-transform duration-700 ease-out [@media(hover:hover)]:group-hover:scale-[1.02]"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none';
            }}
          />
          {/* Gradient overlay for text zone */}
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-brand-navy/70 via-transparent to-transparent" />
          {/* Tagline */}
          <div className="pointer-events-none absolute inset-x-0 bottom-0 px-5 pb-4 sm:px-6 sm:pb-5">
            <p className="text-base font-semibold text-white drop-shadow-[0_2px_4px_rgba(0,0,0,0.3)] sm:text-xl">
              Le stelle parlano. Noi ti aiutiamo ad ascoltarle.
            </p>
            <p className="mt-0.5 text-xs text-white/70 sm:text-sm">
              Consulenze di cartomanzia e astrologia con professionisti verificati
            </p>
          </div>
        </div>
        <p className="mt-3 flex flex-wrap items-center gap-x-2.5 gap-y-1.5 px-1 text-base font-extrabold tracking-wide text-brand-navy sm:text-lg">
          {HERO_CATEGORIES.map((label, i) => (
            <span key={label} className="flex items-center gap-2.5 whitespace-nowrap">
              {i > 0 && <span className="h-1.5 w-1.5 rounded-full bg-brand-teal" aria-hidden="true" />}
              {label}
            </span>
          ))}
        </p>
      </div>
    </section>
  );
}
